import { render, staticRenderFns } from "./BaseLayout.vue?vue&type=template&id=38774620&scoped=true&"
var script = {}
import style0 from "./BaseLayout.vue?vue&type=style&index=0&id=38774620&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38774620",
  null
  
)

export default component.exports